import { Action } from "../actions/index";
import { ActionType } from "../constants";
import { get } from "lodash";

const initialState: any = [];

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_JOBS_LIST: {
      state = get(action, "item");
      return state;
    }
    case ActionType.UPDATE_JOBS_LIST: {
      state = get(action, "item");
      return state;
    }
    
    default:
      return state;
  }
};

export default reducer;
